import React, { useEffect, useState } from 'react';
import classes from './VideoMenu.module.css';
import PrimaryButtonV2 from '../../../components/UI/Buttons/PrimaryButtonV2';
import { convertToRaw, EditorState } from 'draft-js';
import TextEditor from '../../../components/UI/Inputs/TextEditor';
import { htmlToEditorState } from '../../../utils/textEditorUtils';
import { useAppDispatch } from '../../../store/store';
import draftToHtml from 'draftjs-to-html';
import {
  editConsultationRecommendation,
  fetchConsultationRecommendations,
} from '../../../store/slices/consultationRecommendations';

import { useConsultationContext } from '../../../context/ConsultationContext';
import { ContentViewer } from '../../../components/ContentViewer/ContentViewer';
import { useTranslation } from '../../../hooks/useTranslations';
import { toast } from 'react-toastify';
import { CHARACTER_LIMITS, characterLimitMessage } from '../../../utils/characterLimits';

interface Props {
  recommendationId: number;
  recommendationText: string;
  isClosed: boolean;
}

const Recommendations: React.FC<Props> = ({ recommendationId, recommendationText, isClosed }) => {
  let isReports = window.location.pathname.includes('reports');

  const dispatch = useAppDispatch();
  const { selectedSalesOrder, recommendationState, setRecommendationState, addTab } =
    useConsultationContext();
  const { translations } = useTranslation();
  useEffect(() => {
    dispatch(fetchConsultationRecommendations());
  }, [dispatch, selectedSalesOrder]);
  const [editRecommendation, setEditRecommendation] = useState<boolean>(
    selectedSalesOrder?.consultation_recommendations?.consultation_recommendations_description ===
      null
  );
  const onEditorStateChange = (recommendationState: EditorState) => {
    setRecommendationState(recommendationState);
  };

  const handleSave = async () => {
    if (
      recommendationState.getCurrentContent().getPlainText().length >
      CHARACTER_LIMITS.recommendations
    ) {
      toast.error(
        characterLimitMessage(
          translations('error.character_limit'),
          CHARACTER_LIMITS.recommendations
        ),
        { position: toast.POSITION.BOTTOM_RIGHT }
      );
      return;
    }

    const result = await dispatch(
      editConsultationRecommendation({
        consultationsRecommendationDescription: draftToHtml(
          convertToRaw(recommendationState?.getCurrentContent())
        ),
        consultationRecommendationId: recommendationId,
      })
    );
    if (result.meta.requestStatus === 'fulfilled') {
      setRecommendationState(EditorState.createEmpty());
      setEditRecommendation(false);
    }
  };

  const editTab = () => {
    setRecommendationState(htmlToEditorState(recommendationText));
    setEditRecommendation(true);
  };

  const openPreview = () => {
    addTab({ value: 17, text: translations('preview'), isVisible: true });
  };

  return (
    <div style={{ position: 'relative', height: '100%' }}>
      {!selectedSalesOrder?.consultation_recommendations
        ?.consultation_recommendations_description &&
      isClosed &&
      isReports ? (
        <div className="emptyState">{translations('label.empty_state')}</div>
      ) : (
        <div className={classes.inputs}>
          {editRecommendation ? (
            <div>
              <div className={classes.textAreaContainer}>
                <TextEditor
                  editorState={recommendationState}
                  onEditorStateChange={onEditorStateChange}
                  readOnly={isClosed}
                />
              </div>
              <div className={classes.btnWrapper}>
                <PrimaryButtonV2
                  text={translations('save')}
                  buttonStyle={{
                    width: '150px',
                    height: '40px',
                  }}
                  disabled={
                    draftToHtml(convertToRaw(recommendationState?.getCurrentContent())) === '' ||
                    isClosed
                  }
                  onClick={handleSave}
                />
                {!isClosed && (
                  <PrimaryButtonV2
                    text={translations('preview')}
                    buttonStyle={{
                      width: '150px',
                      height: '40px',
                      backgroundColor: '#F4F7FD',
                      border: '1px solid #0B1B5C',
                      color: '#0B1B5C',
                    }}
                    onClick={openPreview}
                  />
                )}
              </div>
            </div>
          ) : (
            <div style={{ padding: '10px' }}>
              <ContentViewer
                title={translations('dhpConsultationDetails.recommendations')}
                content={
                  selectedSalesOrder?.consultation_recommendations
                    ?.consultation_recommendations_description
                }
                {...(!isClosed ? { editTab: editTab } : {})}
              />
              {!isClosed && (
                <PrimaryButtonV2
                  text={translations('preview')}
                  containerStyle={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: '10px',
                  }}
                  buttonStyle={{
                    width: '150px',
                    height: '40px',
                    backgroundColor: '#F4F7FD',
                    border: '1px solid #0B1B5C',
                    color: '#0B1B5C',
                  }}
                  onClick={openPreview}
                />
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export { Recommendations };
